/**
 * Custom hook to manage filter panel logic
 * @param {Object} filters - Current filter state
 * @param {Array<string>} basicFilterKeys - Keys for basic filters
 * @param {Array<string>} extraFilterKeys - Keys for extra filters
 * @returns {Object} Filter panel configuration
 */
export const useFilterPanels = (filters, basicFilterKeys = [], extraFilterKeys = []) => {
  const countSelections = (filterKeys) => {
    return filterKeys.reduce((count, key) => {
      const value = filters[key];
      if (Array.isArray(value) && value.length > 0) {
        return count + value.length;
      }
      return count;
    }, 0);
  };

  const basicCount = countSelections(basicFilterKeys);
  const extraCount = countSelections(extraFilterKeys);
  const hasAnyFilters = basicCount > 0 || extraCount > 0;
  const defaultActiveKeys = hasAnyFilters ? ['1', '2'] : ['1'];

  return {
    basicCount,
    extraCount,
    hasAnyFilters,
    defaultActiveKeys,
    countSelections,
  };
};
